import { useScrollReveal } from '@/hooks/useScrollReveal';

const readingTopics = [
  { icon: 'ri-lightbulb-line', label: '自我理解' },
  { icon: 'ri-heart-line', label: '情緒理解' },
  { icon: 'ri-group-line', label: '人際互動' },
  { icon: 'ri-chat-3-line', label: '溝通與關係' },
  { icon: 'ri-book-read-line', label: '大眾心理學' },
];

export default function PublishingFocus() {
  const section = useScrollReveal();

  return (
    <section
      className="w-full flex items-center px-6 md:px-10 py-20 md:py-28 bg-gradient-to-b from-background-50 via-background-100/60 to-background-50"
      ref={section.ref}
    >
      <div
        className={`w-full max-w-5xl mx-auto transition-all duration-700 ease-out ${
          section.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        {/* Section Label */}
        <div className="flex items-center justify-center gap-2.5 mb-6">
          <span className="block w-5 h-px bg-primary-400/50"></span>
          <span className="text-[13px] font-medium text-primary-600 tracking-[0.15em] uppercase whitespace-nowrap">
            出版方向
          </span>
          <span className="block w-5 h-px bg-primary-400/50"></span>
        </div>

        {/* Title */}
        <div className="text-center mb-4">
          <h2 className="font-heading text-[2.25rem] md:text-[2.75rem] font-semibold text-foreground-950 leading-[1.15] tracking-tight">
            主要出版方向
          </h2>
        </div>

        {/* Core Direction — Main Visual Anchor */}
        <div className="max-w-3xl mx-auto mt-12 mb-16">
          <div className="text-center p-10 md:p-14 rounded-lg bg-accent-100/40 border border-accent-200/40">
            <div className="w-14 h-14 rounded-full bg-accent-200/60 flex items-center justify-center mx-auto mb-5">
              <i className="ri-brain-line text-accent-600 text-xl"></i>
            </div>
            <h3 className="font-heading text-[1.75rem] md:text-[2rem] font-semibold text-foreground-900 mb-4 tracking-tight">
              心理學類書籍
            </h3>
            <p className="text-[15px] md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto font-light">
              出版與心理理解、個人生活及人際互動相關的閱讀內容，協助讀者透過書籍認識不同的心理學觀點。
            </p>
          </div>
        </div>

        {/* Brand Description */}
        <div className="max-w-2xl mx-auto mb-14">
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed text-center font-light">
            樂律文化聚焦心理學類書籍，透過不同心理觀點整理自我理解、情緒與人際互動等生活議題，提供具有閱讀與思考價值的出版內容。
          </p>
        </div>

        {/* Reading Topics */}
        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 mb-16">
          {readingTopics.map((topic) => (
            <div
              key={topic.label}
              className="inline-flex items-center gap-2.5 px-5 py-3 rounded-full bg-background-100 border border-background-200/70 hover:border-secondary-300/60 transition-colors duration-300"
            >
              <div className="w-7 h-7 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className={`${topic.icon} text-secondary-600 text-[13px]`}></i>
              </div>
              <span className="text-[14px] font-medium text-foreground-800 whitespace-nowrap">
                {topic.label}
              </span>
            </div>
          ))}
        </div>

        {/* Content Boundary Note */}
        <div className="max-w-2xl mx-auto p-5 md:p-6 rounded-lg bg-background-100/60 border border-background-200/60">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-full bg-secondary-100/80 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-secondary-500 text-[15px]"></i>
            </div>
            <p className="text-[13px] md:text-[14px] text-foreground-500 leading-relaxed font-light tracking-wide">
              心理學類書籍屬於出版與一般知識閱讀內容，不代表樂律文化提供心理治療、心理諮商、精神疾病診斷或其他醫療服務。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}